// extracted by mini-css-extract-plugin
export var modal = "_bv-0";